import { ChartActions } from '@mode/charts/domain';
import { reportEditActions } from '@mode/report-editor/domain';
import { AppState, WorkspaceFeature, WorkspaceState, WorkspaceView } from '@mode/legacy/types-app-state';
import { combineAllReducers, ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../actions';
import { NotebookActions } from '../actions/notebooks/notebook.actions';
import { WorkspaceActionType } from '../actions/workspace.actions';

export const initialWorkspaceState: WorkspaceState = {
  editorSidebarEnabled: true,
  workspaceView: WorkspaceView.SqlEditor,
  htmlEditorExpanded: false,
};

export function editorSidebarReducer(
  state = initialWorkspaceState.editorSidebarEnabled,
  action: Actions
): WorkspaceState['editorSidebarEnabled'] {
  switch (action.type) {
    case WorkspaceActionType.ToggleEditorSidebar:
      return action.editorSidebarEnabled;
  }

  return state;
}

export function workspaceViewReducer(
  state = initialWorkspaceState.workspaceView,
  action: Actions
): WorkspaceState['workspaceView'] {
  switch (action.type) {
    case ChartActions.selectChart.type: {
      return WorkspaceView.Chart;
    }
    case WorkspaceActionType.SelectSqlEditor: {
      return WorkspaceView.SqlEditor;
    }
    case NotebookActions.Type.Init: {
      return WorkspaceView.Notebook;
    }
    case WorkspaceActionType.SelectReportBuilder: {
      return WorkspaceView.ReportBuilder;
    }
    case reportEditActions.selectLegacyTable.type: {
      return WorkspaceView.DisplayTable;
    }
  }

  return state;
}

export function htmlEditorExpandedReducer(
  state = initialWorkspaceState.htmlEditorExpanded,
  action: Actions
): WorkspaceState['htmlEditorExpanded'] {
  return state;
}

export const workspaceReducers: ReducerTree<AppState, WorkspaceState, Actions> = {
  editorSidebarEnabled: editorSidebarReducer,
  workspaceView: workspaceViewReducer,
  htmlEditorExpanded: htmlEditorExpandedReducer,
};

export const workspaceFeatureReducer = combineAllReducers<WorkspaceFeature, keyof WorkspaceFeature, Actions>({
  workspace: workspaceReducers,
});
